import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";

import { getEventsAcccount } from "../../../../data-store/actions/events-actions";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "20px",
    margin: "20px",
    textAlign: "left",
    minHeight: "400px",
    overflowY: "scroll",
    width: "90%",
    backgroundColor: "#e0e0e0",
  },

  downloadButton: {
    marginBottom: "20px",
  },
}));

export default function AccountData(props) {
  const { business } = props;

  const dispatch = useDispatch();

  const eventsAccount = useSelector(
    (state) => state.events.eventsAccount
  );

  useEffect(() => {
    dispatch(getEventsAcccount());
  }, [dispatch]);

  const classes = useStyles();

  const dollarUSLocale = Intl.NumberFormat("en-US");

  const cleanCsvText = (text) => {
    if (text === null || text === undefined) {
      return "";
    }

    return String(text)
      // Espacios Unicode especiales
      .replace(/[\u00A0\u2007\u202F]/g, " ")

      // Guiones especiales
      .replace(
        /[\u2010\u2011\u2012\u2013\u2014\u2015]/g,
        "-"
      )

      // Comillas simples especiales
      .replace(
        /[\u2018\u2019\u201A\u201B]/g,
        "'"
      )

      // Comillas dobles especiales
      .replace(
        /[\u201C\u201D\u201E\u201F]/g,
        '"'
      )

      // Puntos suspensivos
      .replace(/\u2026/g, "...")

      // Saltos Unicode
      .replace(/[\u2028\u2029]/g, " ")

      // Saltos normales
      .replace(/\r\n/g, " ")
      .replace(/\r/g, " ")
      .replace(/\n/g, " ")

      // Tabs y otros espacios de control
      .replace(/[\t\v\f]/g, " ")

      // Caracteres invisibles
      .replace(
        /[\u200B-\u200D\u2060\uFEFF]/g,
        ""
      )

      // Caracteres de control ASCII
      .replace(
        /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g,
        ""
      )

      // Espacios repetidos
      .replace(/\s+/g, " ")

      .trim();
  };

  const escapeCsvField = (value) => {
    const cleanValue = cleanCsvText(value);

    return `"${cleanValue.replace(/"/g, '""')}"`;
  };

  const downloadCsv = () => {
    if (!eventsAccount) {
      return;
    }

    const separator = ",";
    const rows = [];

    /*
     * Encabezados
     */
    rows.push(
      [
        "ID de Evento",
        "Evento",
        "Fecha",
        "Tipo",
        "Descripción",
        "Monto",
        "Saldo por evento",
        "Documento",
      ]
        .map(escapeCsvField)
        .join(separator)
    );

    let totalGeneral = 0;

    /*
     * Datos
     */
    Object.values(eventsAccount).forEach(
      (specificEventAccount) => {
        let totalEvent = 0;

        Object.values(specificEventAccount)
          .sort(
            (a, b) =>
              Number(a.depositDate) -
              Number(b.depositDate)
          )
          .forEach((item) => {
            const amount =
              Number(item.amount) || 0;

            totalEvent += amount;
            totalGeneral += amount;

            const row = [
              item.eventId || "",
              item.eventName || "",
              item.depositDate || "",
              item.type || "",
              item.description || "",
              amount,
              totalEvent,
              item.document || "",
            ];

            rows.push(
              row
                .map(escapeCsvField)
                .join(separator)
            );
          });
      }
    );

    /*
     * Total general
     */
    rows.push(
      [
        "",
        "",
        "",
        "",
        "TOTAL",
        totalGeneral,
        "",
        "",
      ]
        .map(escapeCsvField)
        .join(separator)
    );

    /*
     * BOM UTF-8:
     * conserva acentos y ñ
     *
     * sep=;
     * le indica a Excel que el delimitador es ;
     *
     * \r\n
     * fuerza salto correcto entre filas
     */
    const csvContent =
      "\uFEFFsep=;\r\n" +
      rows.join("\r\n");

    const blob = new Blob(
      [csvContent],
      {
        type: "text/csv;charset=utf-8;",
      }
    );

    const url =
      URL.createObjectURL(blob);

    const link =
      document.createElement("a");

    link.href = url;

    link.setAttribute(
      "download",
      `estados_cuenta_eventos_${new Date()
        .toISOString()
        .slice(0, 10)}.csv`
    );

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  };

  let totalTable = 0;

  return (
    <Grid
      container
      direction="row"
      alignItems="flex-start"
    >
      <Grid item xs={12}>
        <Typography
          gutterBottom
          variant="h2"
          component="h2"
        >
          Estados de cuenta eventos
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Button
          variant="contained"
          color="primary"
          className={classes.downloadButton}
          onClick={downloadCsv}
          disabled={!eventsAccount}
        >
          Descargar CSV
        </Button>
      </Grid>

      <Grid item xs={12}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">
                ID de Evento
              </TableCell>

              <TableCell align="center">
                Evento
              </TableCell>

              <TableCell align="center">
                Fecha
              </TableCell>

              <TableCell align="center">
                Tipo
              </TableCell>

              <TableCell align="center">
                Descripción
              </TableCell>

              <TableCell align="center">
                Monto
              </TableCell>

              <TableCell align="center">
                Saldo por evento
              </TableCell>

              <TableCell align="center">
                Documento
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {eventsAccount &&
              Object.values(eventsAccount).map(
                (eventID, index) => {
                  const specificEventAccount =
                    eventID;

                  let totalEvent = 0;

                  return Object.values(
                    specificEventAccount
                  )
                    .sort(
                      (a, b) =>
                        Number(
                          a.depositDate
                        ) -
                        Number(
                          b.depositDate
                        )
                    )
                    .map(
                      (itemNew, i) => {
                        const amount =
                          Number(
                            itemNew.amount
                          ) || 0;

                        totalEvent += amount;
                        totalTable += amount;

                        return (
                          <TableRow
                            key={`${index}-${i}`}
                          >
                            <TableCell align="center">
                              {itemNew.eventId}
                            </TableCell>

                            <TableCell align="center">
                              {itemNew.eventName}
                            </TableCell>

                            <TableCell align="center">
                              {itemNew.depositDate}
                            </TableCell>

                            <TableCell align="center">
                              {itemNew.type}
                            </TableCell>

                            <TableCell align="center">
                              {itemNew.description}
                            </TableCell>

                            <TableCell align="center">
                              {dollarUSLocale.format(
                                amount
                              )}
                            </TableCell>

                            <TableCell align="center">
                              {dollarUSLocale.format(
                                totalEvent
                              )}
                            </TableCell>

                            <TableCell align="center">
                              {itemNew.document && (
                                <Button
                                  target="_blank"
                                  href={
                                    itemNew.document
                                  }
                                >
                                  Ver
                                </Button>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      }
                    );
                }
              )}

            <TableRow>
              <TableCell />
              <TableCell />
              <TableCell />
              <TableCell />

              <TableCell align="right">
                <strong>
                  TOTAL
                </strong>
              </TableCell>

              <TableCell align="center">
                <strong>
                  {dollarUSLocale.format(
                    totalTable
                  )}
                </strong>
              </TableCell>

              <TableCell />
              <TableCell />
            </TableRow>
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  );
}